import React from 'react';
import { Link } from 'react-router-dom';

import { trackSharePageClickHelp } from '../../../analytics';

import { getHelpUrl } from '../../../utils';

interface Props {
  type: string;
}

const ShareFooter: React.FC<Props> = (props) => {
  const { type } = props;

  const socials = [
    {
      name: 'Instagram',
      link: 'https://www.instagram.com/crowdclip/',
      image:
        'http://cdn.mcauto-images-production.sendgrid.net/47f51ffc24a0aec6/27a34d6d-b3ef-40b0-9d89-aaaba1cc7674/256x253.png',
    },
    {
      name: 'Facebook',
      link: 'https://www.facebook.com/crowdnclip/',
      image:
        'http://cdn.mcauto-images-production.sendgrid.net/47f51ffc24a0aec6/f4934c0e-cddf-451a-a2f7-1213e8aa8959/256x256.png',
    },
    {
      name: 'Twitter',
      link: 'https://twitter.com/crowdclip/',
      image:
        'http://cdn.mcauto-images-production.sendgrid.net/47f51ffc24a0aec6/4d1b66cb-62fd-44bd-903d-6ee4b8358865/256x256.png',
    },
    {
      name: 'LinkedIn',
      link: 'https://au.linkedin.com/company/crowdclip',
      image:
        'http://cdn.mcauto-images-production.sendgrid.net/47f51ffc24a0aec6/1a9a4fa0-73cc-40e9-bf7e-21de98bc7ca0/256x256.png',
    },
  ];

  return (
    <div className="w-full flex flex-col my-7 gap-2 text-center text-xs text-[#5e5e5e]">
      <div>
        Need help? Click{' '}
        <Link
          to={getHelpUrl('attendee', 'share-video')}
          target="_blank"
          onClick={() => trackSharePageClickHelp(type)}
        >
          here
        </Link>
      </div>

      <div>
        This video was automatically curated using CrowdClip's automated AI
        video editing software.
      </div>

      <div>
        If you would like to create your own premium video content at the click
        of a button, simply visit{' '}
        <a href="https://crowdclip.com" target="_blank" rel="noreferrer">
          www.crowdclip.com
        </a>
        .
      </div>

      <div className="flex justify-center mt-2 gap-2.5">
        {socials.map((social) => (
          <a
            href={social.link}
            target="_blank"
            rel="noreferrer"
            key={social.name}
          >
            <img
              src={social.image}
              className="w-6 aspect-square"
              alt={`${social.name} Icon`}
            />
          </a>
        ))}
      </div>

      <hr className="my-4" />

      <div className="italic">
        Copyright &copy; 2026 CrowdClip&reg;, All Rights Reserved
      </div>
    </div>
  );
};

export default ShareFooter;
